import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'callsmart-legal',
  templateUrl: './legal.component.html'
})
export class LegalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
